import React from 'react';
import sendEvent from '../../helpers/tracking';

import './NotificationBanner.scss';

export default function NotificationBanner(props) {
  const { message, url, buttonLabel } = props.item;

  return (
    <section className="notificationBanner">
      <p>{message}</p>
      <button onClick={() => handleClick()}>{buttonLabel}</button>
    </section>
  );

  function handleClick() {
    sendEvent('UserNotification', 'Click', buttonLabel);

    // Wait some time to ensure Matomo query has been sent
    setTimeout(() => (location.href = url), 500);
  }
}
